/**
 * The map's single root: the workshop and its main question.
 *
 * The scenarios used to be six separate roots, and the question the whole
 * room was answering — `settings.workshopGoal` — was a sentence in a settings
 * row. Here it becomes the card everything hangs from: the workshop's title
 * as the card's kind (where a consequence says "Seuraus"), the short question
 * as its text and the full goal as its description. Display only; nothing is stored, and nothing below the scenarios
 * changes.
 */
export const ROOT_ID = 'map-root';

const hasParent = (n) => Boolean(n.parentId || n.parent_id || (Array.isArray(n.parentIds) && n.parentIds.length));

// `question` is the short form (`settings.mainQuestion`), the card's title;
// `goal` the full sentence (`settings.workshopGoal`), the card's description.
// A workshop goal is usually a paragraph, and a paragraph is not a title.
export function withRootNode(pathways, { title, question, goal } = {}) {
  const text = question || goal;
  if (!text || !Array.isArray(pathways) || !pathways.length) return pathways;
  const roots = pathways.filter((n) => !hasParent(n) && (n.depth || 0) === 0);
  if (!roots.length) return pathways;
  const root = {
    id: ROOT_ID,
    type: 'root',
    isRoot: true,
    rootLabel: title || '',
    text,
    title: text,
    description: question && goal && goal !== question ? goal : null,
    depth: -1,
    parentId: null,
    parentIds: [],
    created_by: 'system',
    is_scenario_starter: false,
  };
  return [root, ...pathways.map((n) => (
    hasParent(n) || (n.depth || 0) !== 0 ? n : { ...n, parentId: ROOT_ID, parentIds: [ROOT_ID] }
  ))];
}
